import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { guardLoadingStatesAtom } from '../components/loadingAtoms.js';

/**
 * Hook for guards to manage their loading state in the global loading page
 * @param guardId - Unique identifier for the guard
 * @param isLoading - Current loading state
 */
function useGuardLoadingState(guardId, isLoading) {
    const setGuardLoadingStates = useSetAtom(guardLoadingStatesAtom);
    useEffect(() => {
        // Update the loading state for this guard
        setGuardLoadingStates((prev) => ({
            ...prev,
            [guardId]: isLoading,
        }));
        // Cleanup: remove this guard's loading state when unmounted
        return () => {
            setGuardLoadingStates((prev) => {
                const next = { ...prev };
                delete next[guardId];
                return next;
            });
        };
    }, [guardId, isLoading, setGuardLoadingStates]);
}

export { useGuardLoadingState };
//# sourceMappingURL=useGuardLoadingState.js.map
